// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const gumshoos: PokeData = {
  "id": 735,
  "name": "gumshoos",
  "height": 7,
  "weight": 142,
  "base_experience": 146,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "sand-attack",
    "tackle",
    "take-down",
    "thrash",
    "leer",
    "bite",
    "bide",
    "rest",
    "hyper-fang",
    "super-fang",
    "scary-face",
    "mud-slap",
    "pursuit",
    "crunch",
    "yawn",
    "odor-sleuth",
    "payback",
    "work-up"
  ],
  "moves": [
    "tackle",
    "leer",
    "bite",
    "scary-face",
    "mud-slap",
    "pursuit",
    "crunch",
    "supersonic",
    "scratch",
    "splash",
    "quick-attack",
    "refresh",
    "headbutt"
  ],
  "evolution_chain": {
    "id": 378,
    "item": null,
    "species": [
      {
        "name": "yungoos",
        "order": 734,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "gumshoos",
        "order": 735,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 734,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 20,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "day",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 129,
    "speed": 79,
    "ability_power": 192
  },
  "stat_changes": [],
  "catch_rate": 127,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
